import React from 'react'
import FormControl from "@material-ui/core/FormControl";
import FormGroup from '@material-ui/core/FormGroup';
import TextField from "@material-ui/core/TextField";
import { Context as InvoicesContext } from "../context/invoices.context";
import { Context as WalletContext } from "../context/wallet.context";
import { Context as DealsContext } from "../context/deals.context";
import { useState, useContext, useEffect } from 'react';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
  } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";


import Typography from '@material-ui/core/Typography';

function AutopaySettings({contextParent}) {


    const [processDaySettings, setProcessDaySettings] = useState('day')
    const [fieldDetail, setFieldDetail] = useState('')
   

    //Due to the context for autopay being split across states having to detrimen which one to use. 
    const invoiceState = useContext(InvoicesContext);
    const dealState = useContext(DealsContext)
    const walletState = useContext(WalletContext);


    const contextState = (contextParent === 'wallet') ? walletState : ((contextParent === 'autoPayModel' && dealState) ? dealState : invoiceState );
  
  
    const [autopayReminderDays, setAutopayReminderDays] = useState(contextState.state.autoPay.autoPaySettings.autopay_reminder_days)
    const [maxAmount, setMaxAmount] = useState(contextState.state.autoPay.autoPaySettings.autopay_max_amount)
    const [amountOverride, setAmountOverride] = useState(contextState.state.autoPay.autoPaySettings.autopay_amount_override)
    const [payDayAdvance, setPayDayAdvance] = useState(contextState.state.autoPay.autoPaySettings.autopay_pay_advance_days)
    const [payDayofMonth, setPayDayofMonth] = useState(contextState.state.autoPay.autoPaySettings.autopay_pay_day_of_month)

    const [autopayStartDate, setAutopayStartDate] = useState(contextState.state.autoPay.autoPaySettings.autopay_start_date)

    useEffect(() => {
        if(contextState.state.autoPay.autoPaySettings.autopay_start_date === '' || contextState.state.autoPay.autoPaySettings.autopay_start_date == null ){
            let d = new Date()
            d.setMonth(d.getMonth()+1, 1)
            
            setAutopayStartDate(d)

            contextState.state.autoPay.autoPaySettings.autopay_start_date = d.getFullYear()  + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        }

    }, [])



    const styles = {
        formGroupStyle : {

            textAlign: 'left', 

        },
        textField : {
            marginRight: 15,
            width: 150,
            marginBottom:10
        },
        sectionTitle : {
            marginBottom: 10,
            textAlign: 'left',
            marginLeft: 0,
            fontSize: 'medium'
        },
    }


    const stringToWholeNumber = (value) => {
        return value.replace(/[^0-9]/g, '')
      } 
    
    const stringToFloat = (value) => {
    return value.replace(/[^0-9\.]/g, '')
    } 
    

    const showFieldDetails = (e) => {
        e.preventDefault();
        setFieldDetail(e.target.id )
    }

    const clearFieldDetail = (e) => {
        setFieldDetail('')
    }

    const handleAutopayChange = (e, fieldId) => {
        e.preventDefault();
  
        let updatedValue = 0
  
        switch(fieldId){
          case 'autopay_reminder_days' :
            updatedValue = stringToWholeNumber(e.target.value)
            setAutopayReminderDays(updatedValue);
            contextState.state.autoPay.autoPaySettings.autopay_reminder_days = updatedValue
            break
          case 'autopay_pay_advance_days' :
            updatedValue = stringToWholeNumber(e.target.value)
            setPayDayAdvance(updatedValue);
            contextState.state.autoPay.autoPaySettings.autopay_pay_advance_days = updatedValue
            setPayDayofMonth('');
            contextState.state.autoPay.autoPaySettings.autopay_pay_day_of_month = ''
            break
          case 'autopay_pay_day_of_month' :
            updatedValue = stringToWholeNumber(e.target.value)
  
            if(updatedValue > 28){
              updatedValue = 28
            }
  
            setPayDayofMonth(updatedValue);
            contextState.state.autoPay.autoPaySettings.autopay_pay_day_of_month = updatedValue
            setPayDayAdvance('');
            contextState.state.autoPay.autoPaySettings.autopay_pay_advance_days = ''
            break
          case 'autopay_max_amount' :
            updatedValue = stringToFloat(e.target.value)
            setMaxAmount(updatedValue);
            contextState.state.autoPay.autoPaySettings.autopay_max_amount = updatedValue
            break
          case 'autopay_amount_override' :
            updatedValue = stringToFloat(e.target.value)
            setAmountOverride(updatedValue);
            contextState.state.autoPay.autoPaySettings.autopay_amount_override = updatedValue
            break
          default :
            return
  
        }        
        
    }


    const handleAutopayStartDateChange = (date) => {
        if( date instanceof Date && !isNaN(date)){
            setAutopayStartDate(date);
            contextState.state.autoPay.autoPaySettings.autopay_start_date = date.getFullYear()  + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        } else {
            setAutopayStartDate('');
            contextState.state.autoPay.autoPaySettings.autopay_start_date = ''
        }    
      };

      const xLang = (string) => {
		return string
	}

    return (
        <div>
            <FormControl component="fieldset">

                <Typography variant="h6" style={ styles.sectionTitle}><x-lang>Activate Autopay</x-lang></Typography>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        id="autopay_start_date"
                        label={xLang("Start Date")}
                        format="MM/dd/yyyy"
                        value={autopayStartDate}
                        onFocus={showFieldDetails }
                        onBlur={clearFieldDetail}
                        onChange={handleAutopayStartDateChange}
                        inputVariant="outlined"
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                        }}
                        style={{ marginRight: 15, width: 175 }}
                    />
                </MuiPickersUtilsProvider>

                {fieldDetail === "autopay_start_date" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left', fontSize: 10, marginBottom: 10}}>
                    **<x-lang>Start Date will begin processing all invoices without a due date on your start date</x-lang>. <br/>
                    <x-lang>Invoices with a due date will only be processed if after the start date</x-lang>. <br />
                    <x-lang>Autopay settings will not be enabled until the start date</x-lang>.
                    <x-lang>Meaning you could recive a notification and have a payment on the day of the start date. Regardless if you have a reminder day set or process day set</x-lang>.
                </Typography>)}

                <Typography variant="h6" style={ styles.sectionTitle}><x-lang>Autopay Settings</x-lang>:</Typography>
                <FormGroup row style={ styles.formGroupStyle }>
                    <TextField
                        type="number"
                        onFocus={showFieldDetails} 
                        onBlur={clearFieldDetail} 
                        onChange={(e)=> handleAutopayChange(e, 'autopay_reminder_days')}
                        id="autopay_reminder_days" 
                        style={styles.textField} 
                        label={xLang("Reminder Days")}
                        value={autopayReminderDays}
                        variant="outlined" 
                    
                    />

                    <TextField
                        type="number"
                        onFocus={showFieldDetails} 
                        onBlur={clearFieldDetail}
                        onChange={(e)=> handleAutopayChange(e, 'autopay_max_amount')}
                        id="autopay_max_amount"
                        style={styles.textField} 
                        label={xLang("Max Amount")}
                        value={maxAmount}
                        variant="outlined"
                    />

                    <TextField
                        type="number"
                        onFocus={showFieldDetails }
                        onBlur={clearFieldDetail}
                        onChange={(e)=> handleAutopayChange(e, 'autopay_amount_override')}
                        id="autopay_amount_override"
                        style={styles.textField} 
                        label={xLang("Amount Override")}
                        value={amountOverride}
                        variant="outlined"
                    />


                    {fieldDetail === "autopay_max_amount" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left' }}>
                        **<x-lang>Max Amount caps amount that can be processed</x-lang>.
                    </Typography>)}
                    {fieldDetail === "autopay_amount_override" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left' }}>
                        **<x-lang>Amount Override will proces this amount intead of the invoice balance. In the event that your override is greater then the invoice balance you will only be billed the invoice balance</x-lang>
                    </Typography>)}

                    {fieldDetail === "autopay_reminder_days" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left' }}>
                        **<x-lang>Reminder Days receive an email reminder this many days before the invoice due date.</x-lang>
                    </Typography>)}



                </FormGroup>


                <Typography variant="h6" style={ styles.sectionTitle}><x-lang>Autopay Process Day Settings</x-lang>:</Typography>
                <Typography variant={"caption"} style={{ color: "grey", textAlign: 'left', marginBottom:20, marginTop:-12 }}>
                <x-lang>Please select only one option below.</x-lang>
                </Typography>

                <FormGroup row style={ styles.formGroupStyle }>
                    <TextField
                        type="number"
                        onFocus={(e) => { showFieldDetails(e); setPayDayofMonth(''); }}
                        onBlur={clearFieldDetail}
                        onChange={(e)=> handleAutopayChange(e, 'autopay_pay_advance_days')}
                        id="autopay_pay_advance_days"
                        style={styles.textField}
                        label={xLang("Pay Day Advance")}
                        value={payDayAdvance}
                        variant="outlined"
                    />

                    <TextField
                        type="number"
                        onFocus={(e) => { showFieldDetails(e); setPayDayAdvance(''); }}
                        onBlur={clearFieldDetail}
                        onChange={(e)=> handleAutopayChange(e, 'autopay_pay_day_of_month')}
                        id="autopay_pay_day_of_month"
                        InputProps={{ inputProps: { min: 1, max: 28 } }}
                        style={styles.textField}
                        label={xLang("Day of Month")}
                        value={payDayofMonth}
                        variant="outlined"
                    />

                    {fieldDetail === "autopay_pay_advance_days" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left' }}>
                        **<x-lang>Pay Day Advance will process payments this many days before the invoice due date.</x-lang>
                    </Typography>)}


                    {fieldDetail === "autopay_pay_day_of_month" && (<Typography variant={"caption"} style={{ color: "grey", textAlign: 'left' }}>
                        **<x-lang>Day of Month will process payments on this day of the month that match the month of the invoice due date. This could result on late payment if Day of Month is after invoice due date.</x-lang>
                    </Typography>)}


                </FormGroup>
            </FormControl>

        </div>
    )
}



export default AutopaySettings
